
export interface EscolaDTO {
  coop: string;
  id: number;
  nome: string;
}

export type ProgramaCheckedAno = {
  disabled: boolean,
  checked: boolean;
  anoImplementacao: string;
};

export enum ProgramaKey {
  A_UNIAO_FAZ_A_VIDA = 0,
  COOPERATIVAS_ESCOLARES = 1,
  JORNADA_DE_EDUCACAO_FINANCEIRA = 2,
}

export enum ProgramaDescricao {
  A_UNIAO_FAZ_A_VIDA = 'A União Faz a Vida',
  COOPERATIVAS_ESCOLARES = 'Cooperativas Escolares',
  JORNADA_DE_EDUCACAO_FINANCEIRA = 'Jornada da Educação Financeira nas Escolas',
}

export const ESCOLA_ETAPAS_PARAMS_URL = {
  CADASTRO: 'cadastro',
  DUPLICAR: 'duplicar',
  EDITAR: 'edicao',
  PERIODO_CADASTRO: 'periodo-cadastro'
};

export const CENTRALIZADO = 1;
export const UNIAO_FAZ_A_VIDA_VALOR = ProgramaKey.A_UNIAO_FAZ_A_VIDA;
export const allProgramas = () =>
  [
    {
      value: ProgramaKey.A_UNIAO_FAZ_A_VIDA,
      description: ProgramaDescricao.A_UNIAO_FAZ_A_VIDA,
    },
    {
      value: ProgramaKey.COOPERATIVAS_ESCOLARES,
      description: ProgramaDescricao.COOPERATIVAS_ESCOLARES,
    },
    {
      value: ProgramaKey.JORNADA_DE_EDUCACAO_FINANCEIRA,
      description: ProgramaDescricao.JORNADA_DE_EDUCACAO_FINANCEIRA,
    },
  ];
